"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Domain = void 0;
class Domain {
    constructor() {
    }
    static getAttributeTypeMap() {
        return Domain.attributeTypeMap;
    }
}
exports.Domain = Domain;
Domain.discriminator = undefined;
Domain.attributeTypeMap = [
    {
        "name": "portalId",
        "baseName": "portalId",
        "type": "number",
        "format": "int32"
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "number",
        "format": "int64"
    },
    {
        "name": "created",
        "baseName": "created",
        "type": "number",
        "format": "int64"
    },
    {
        "name": "updated",
        "baseName": "updated",
        "type": "number",
        "format": "int64"
    },
    {
        "name": "domain",
        "baseName": "domain",
        "type": "string",
        "format": ""
    },
    {
        "name": "primaryLandingPage",
        "baseName": "primaryLandingPage",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "primaryEmail",
        "baseName": "primaryEmail",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "primaryBlog",
        "baseName": "primaryBlog",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "primaryBlogPost",
        "baseName": "primaryBlogPost",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "primarySitePage",
        "baseName": "primarySitePage",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "primaryKnowledge",
        "baseName": "primaryKnowledge",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "primaryLegacyPage",
        "baseName": "primaryLegacyPage",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "primaryClickTracking",
        "baseName": "primaryClickTracking",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "fullCategoryKey",
        "baseName": "fullCategoryKey",
        "type": "string",
        "format": ""
    },
    {
        "name": "secondaryToDomain",
        "baseName": "secondaryToDomain",
        "type": "string",
        "format": ""
    },
    {
        "name": "isResolving",
        "baseName": "isResolving",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "isDnsCorrect",
        "baseName": "isDnsCorrect",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "manuallyMarkedAsResolving",
        "baseName": "manuallyMarkedAsResolving",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "consecutiveNonResolvingCount",
        "baseName": "consecutiveNonResolvingCount",
        "type": "number",
        "format": "int32"
    },
    {
        "name": "sslCname",
        "baseName": "sslCname",
        "type": "string",
        "format": ""
    },
    {
        "name": "isSslEnabled",
        "baseName": "isSslEnabled",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "isSslOnly",
        "baseName": "isSslOnly",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "certificateId",
        "baseName": "certificateId",
        "type": "number",
        "format": "int64"
    },
    {
        "name": "sslRequestId",
        "baseName": "sslRequestId",
        "type": "number",
        "format": "int64"
    },
    {
        "name": "isUsedForBlogPost",
        "baseName": "isUsedForBlogPost",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "isUsedForSitePage",
        "baseName": "isUsedForSitePage",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "isUsedForLandingPage",
        "baseName": "isUsedForLandingPage",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "isUsedForEmail",
        "baseName": "isUsedForEmail",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "isUsedForKnowledge",
        "baseName": "isUsedForKnowledge",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "setupTaskId",
        "baseName": "setupTaskId",
        "type": "number",
        "format": "int64"
    },
    {
        "name": "isSetupComplete",
        "baseName": "isSetupComplete",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "setUpLanguage",
        "baseName": "setUpLanguage",
        "type": "string",
        "format": ""
    },
    {
        "name": "teamIds",
        "baseName": "teamIds",
        "type": "Array<number>",
        "format": "int64"
    },
    {
        "name": "actualCname",
        "baseName": "actualCname",
        "type": "string",
        "format": ""
    },
    {
        "name": "correctCname",
        "baseName": "correctCname",
        "type": "string",
        "format": ""
    },
    {
        "name": "actualIp",
        "baseName": "actualIp",
        "type": "string",
        "format": ""
    },
    {
        "name": "apexResolutionStatus",
        "baseName": "apexResolutionStatus",
        "type": "DomainApexResolutionStatusEnum",
        "format": ""
    },
    {
        "name": "apexDomain",
        "baseName": "apexDomain",
        "type": "string",
        "format": ""
    },
    {
        "name": "publicSuffix",
        "baseName": "publicSuffix",
        "type": "string",
        "format": ""
    },
    {
        "name": "apexIpAddresses",
        "baseName": "apexIpAddresses",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "siteId",
        "baseName": "siteId",
        "type": "number",
        "format": "int64"
    },
    {
        "name": "brandId",
        "baseName": "brandId",
        "type": "number",
        "format": "int64"
    },
    {
        "name": "deletable",
        "baseName": "deletable",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "domainCdnConfig",
        "baseName": "domainCdnConfig",
        "type": "DomainCdnConfig",
        "format": ""
    },
    {
        "name": "setupInfo",
        "baseName": "setupInfo",
        "type": "DomainSetupInfo",
        "format": ""
    },
    {
        "name": "derivedBrandName",
        "baseName": "derivedBrandName",
        "type": "string",
        "format": ""
    },
    {
        "name": "createdById",
        "baseName": "createdById",
        "type": "number",
        "format": "int32"
    },
    {
        "name": "updatedById",
        "baseName": "updatedById",
        "type": "number",
        "format": "int32"
    },
    {
        "name": "label",
        "baseName": "label",
        "type": "string",
        "format": ""
    },
    {
        "name": "isAnyPrimary",
        "baseName": "isAnyPrimary",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "isLegacyDomain",
        "baseName": "isLegacyDomain",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "isInternalDomain",
        "baseName": "isInternalDomain",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "isResolvingInternalProperty",
        "baseName": "isResolvingInternalProperty",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "isResolvingIgnoringManuallyMarkedAsResolving",
        "baseName": "isResolvingIgnoringManuallyMarkedAsResolving",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "isUsedForAnyContentType",
        "baseName": "isUsedForAnyContentType",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "isLegacy",
        "baseName": "isLegacy",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "authorAt",
        "baseName": "authorAt",
        "type": "number",
        "format": "int64"
    },
    {
        "name": "cosObjectType",
        "baseName": "cosObjectType",
        "type": "DomainCosObjectTypeEnum",
        "format": ""
    },
    {
        "name": "cdnPurgeEmbargoTime",
        "baseName": "cdnPurgeEmbargoTime",
        "type": "number",
        "format": "int64"
    },
    {
        "name": "isStagingDomain",
        "baseName": "isStagingDomain",
        "type": "boolean",
        "format": ""
    }
];
//# sourceMappingURL=Domain.js.map